module.exports = __webpack_public_path__ + "static/media/pintor.a602a552.png";